<template>
	<div>
		<div style="height: 34px;" v-show="isShow()"></div>
		<div class="breadcrumbBox" v-show="isShow()" :style="{ left: getIsCollapseStatus ? '64px' : '200px' }">
			<el-scrollbar class="scroll-container">
				<div class="breadcrumb flex_start">
					<div class="tagViews flex_center" v-for="(tags,index) in visitedViews" :key="index"
					:class="isActive(tags)?'active':''" @click="breadcrumbChange(tags)" @contextmenu.prevent="openMenu(tags,$event,index)">
						<div class="tagViewTxt">{{ tags.title }}</div>
						<img v-if="isActive(tags)" src="../../assets/icon/closeIconWhite.png" alt="" @click.stop="breadcrumbDelete(tags,index)" />
						<img v-else src="../../assets/icon/closeIcon.png" alt="" @click.stop="breadcrumbDelete(tags,index)" />
					</div>
				</div>
			</el-scrollbar>
			<ul v-show="menuVisible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
			  <li @click="refreshSelectedTag(selectedTag)"><i class="el-icon-refresh-right"></i> 刷新页面</li>
			  <li @click="closeSelectedTag(selectedTag,selectedIndex)"><i class="el-icon-close"></i> 关闭当前</li>
			  <li @click="closeOtherTag(selectedTag,selectedIndex)"><i class="el-icon-circle-close"></i> 关闭其他</li>
			  <li @click="closeAllTag"><i class="el-icon-circle-close"></i> 全部关闭</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
		  return {
		    menuVisible: false,
				top: 32,
				left: 0,
				selectedTag: null,
				selectedIndex: 0
		  }
		},
		computed: {
			visitedViews() {
			  return this.$store.state.visitedViews
			},
			// 获取侧导航折叠状态，使面包屑与主内容保持相同的左侧位置
			getIsCollapseStatus() {
				return this.$store.getters.getIsCollapseStatus
			},
		},
		watch: {
		  menuVisible(value) {
		    if (value) {
		      document.body.addEventListener('click', this.closeMenu)
		    } else {
		      document.body.removeEventListener('click', this.closeMenu)
		    }
		  }
		},
		methods: {
			closeMenu() {
			  this.menuVisible = false
			},
			isActive(route) {
			  return route.path === this.$route.path
			},
			isShow(){
				return this.$route.path !== '/home/home'
			},
			breadcrumbChange(item){
				this.$router.push({
					path: item.path,
					query: {
						sideId: item.id
					}
				})
			},
			breadcrumbDelete(item,index){
				if(this.isActive(item)){
					if(index == this.visitedViews.length-1 && this.visitedViews.length>1){
						this.breadcrumbChange(this.visitedViews[index-1])
					}else if(index == 0 && this.visitedViews.length>1){
						this.breadcrumbChange(this.visitedViews[index+1])
					}else{
						if(this.visitedViews.length == 1){
							this.$router.push('/companyManage/companyManage');
						}else{
							// 跳转至右侧相邻页面
							this.breadcrumbChange(this.visitedViews[index+1])
						}
					}
				}
				this.$store.commit('deleteVisitedViews', index);
			},
			openMenu(tag, e,index) {
			  const menuMinWidth = 105
			  const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
			  const offsetWidth = this.$el.offsetWidth // container width
			  const maxLeft = offsetWidth - menuMinWidth // left boundary
			  const left = e.clientX - offsetLeft + 15 // 15: margin right
			  if (left > maxLeft) {
			    this.left = maxLeft
			  } else {
			    this.left = left
			  }
			  // this.top = e.clientY
			  this.menuVisible = true
			  this.selectedTag = tag
				this.selectedIndex = index
			},
			refreshSelectedTag(view) {
				location.reload();
			  // this.$tab.refreshPage(view);
			},
			closeSelectedTag(item,index){
				this.breadcrumbDelete(item,index);
			},
			closeOtherTag(item,index){
				this.$store.commit('closeVisitedViewsOther', item);
				if(!this.isActive(item)){
					this.breadcrumbChange(item);
				}
				// console.log(item)
			},
			closeAllTag(){
				this.$store.commit('closeAllVisitedViews');
			},
		},
	}
</script>

<style scoped>
	.breadcrumbBox{
		position: fixed;
		top: 64px;
		left: 200px;
		right: 0;
		height: 34px;
		z-index: 10;
	}
	.scroll-container{
		width: 100%;
	}
	.breadcrumb {
		height: 34px;
		/* width: 100%; */
		border-bottom: 1px solid #EFEFEF;
		padding: 0 10px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}
	.tagViews{
		align-items: center;
		cursor: pointer;
		border: 1px solid #E0E0E5;
		border-radius: 4px;
		padding: 0 10px;
		height: 24px;
		box-sizing: border-box;
		color: #999999;
		margin-right: 10px;
		flex-shrink: 0;
	}
	.tagViewTxt{
		font-size: 12px;
	}
	.tagViews img{
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}
	.active{
		background: #007FFF;
		border-color: #007FFF;
		color: #FFFFFF;
	}
	.contextmenu {
	  margin: 0;
	  background: #fff;
	  z-index: 3000;
	  position: absolute;
	  list-style-type: none;
	  padding: 5px 0;
	  border-radius: 4px;
	  font-size: 12px;
	  font-weight: 400;
	  color: #333;
	  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
	  
	}
	.contextmenu li{
		margin: 0;
		padding: 7px 16px;
		cursor: pointer;
	}
	.contextmenu li:hover{
		background: #eee;
	}
</style>
